export class TextHelper {
	moneyMask(value) {
		const formattedValue = value?.toLocaleString('es-CL', { style: 'currency', currency: 'CLP' });
		return formattedValue?.replace(/\.00$/, '');
	}

	slugify(text) {
		return text
			.toString()
			.toLowerCase()
			.trim()
			.replace(/\s+/g, '-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\-\-+/g, '-');
	}

	capitalize(text) {
		if (!text) return '';
		
		return text.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
	}

	slugToCamelCase(slug){
		return slug
			.split('-')
			.map((word, index) => 
				index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
			)
			.join('');
	}

	formatRut(rut) {
		if(!rut){
			return ''
		}
		const cleanRut = rut.replace(/[^0-9kK]/g, '').toUpperCase();
	
		const body = cleanRut.slice(0, -1);
		const dv = cleanRut.slice(-1);

		let formattedBody = body;
		if (body.length > 6) {
			formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		}
	
		return `${formattedBody}-${dv}`;
	}

	createWhatsAppLink(number, message) {
        const cleanNumber = number.replace(/\D/g, "")
        const encodedMessage = encodeURIComponent(message);
        return `https://wa.me/${cleanNumber}?text=${encodedMessage}`;
    }
}

export const textHelper = new TextHelper();

